export default __webpack_public_path__ + "static/media/fashion.c559f40f.png";